import React from 'react';
import { Button } from './ui/Button';
export function FinalCTA() {
  return <section className="font-heading overflow-hidden" data-id="element-35">
      <div className="flex flex-col lg:flex-row min-h-[500px]" data-id="element-36">
        {/* Image Side */}
        <div className="w-full lg:w-1/2 aspect-video lg:aspect-auto lg:min-h-[500px] relative" data-id="element-37">
          <img src="https://cdn.magicpatterns.com/uploads/bySxTZ86DQWWMzb1CECowh/IMG_1111-9acd7d6f-1920w.webp" alt="Busy Drones Cleaners LLC team with branded van" className="w-full h-full object-cover object-center absolute inset-0" data-id="element-38" />
        </div>

        {/* Text Side */}
        <div className="w-full lg:w-1/2 bg-[#1B3A5C] flex items-center" data-id="element-39">
          <div className="w-full py-8 px-6 sm:px-8 lg:py-[60px] lg:px-[60px] text-center lg:text-left" data-id="element-40">
            <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold text-white mb-6 uppercase tracking-tight" data-id="element-41">
              Ready to Take Flight?
            </h2>

            <p className="text-white/90 text-lg md:text-xl mb-10 max-w-lg mx-auto lg:mx-0 font-medium" data-id="element-42">
              Get a free estimate and see how drone-powered cleaning can save
              you time and money.
            </p>

            <div className="flex flex-col sm:flex-row items-center lg:items-start justify-center lg:justify-start gap-4" data-id="element-43">
              <Button className="w-full sm:w-auto bg-[#F5A623] hover:bg-[#E09520] text-[#1B3A5C] font-bold text-lg h-14 px-10 rounded-lg shadow-lg" data-id="element-44">
                Get a Free Estimate
              </Button>
              <Button variant="outline" className="w-full sm:w-auto bg-transparent hover:bg-white/10 text-white border-2 border-white font-bold text-lg h-14 px-10 rounded-lg" data-id="element-45">
                Call 928-509-0360
              </Button>
            </div>
          </div>
        </div>
      </div>
    </section>;
}